import { MIN_PIN_LENGTH, PIN_SPECIAL_CHARACTERS } from '../constants'

interface ValidationReturnType {
   isValid: boolean
   errorMessage: string | null | undefined
}

export const validatePinComplexity = (pin: string): ValidationReturnType => {
   if (pin.length < MIN_PIN_LENGTH) {
      return {
         isValid: false,
         errorMessage: `Must be at least ${MIN_PIN_LENGTH} characters`
      }
   }
   if (!/[A-Z]/.test(pin)) {
      return {
         isValid: false,
         errorMessage: 'Must contain at least one uppercase letter (A-Z)'
      }
   }
   if (!/[a-z]/.test(pin)) {
      return {
         isValid: false,
         errorMessage: 'Must contain at least one lowercase letter (a-z)'
      }
   }
   if (!/[0-9]/.test(pin)) {
      return {
         isValid: false,
         errorMessage: 'Must contain at least one numeric digit (0-9)'
      }
   }
   if (![...pin].some(c => PIN_SPECIAL_CHARACTERS.has(c))) {
      return {
         isValid: false,
         errorMessage: 'Must contain at least one special character'
      }
   }

   return {
      isValid: true,
      errorMessage: null
   }
}
